import { Navigate, Outlet, useParams, useLocation } from "react-router-dom";
import { useAuth } from "@/layouts/AuthContext";

export default function GuestGuard() {
    const { isAuthenticated, user } = useAuth();
    const { lang } = useParams();
    const baseRoute = `/${lang || "id"}`;

    const location = useLocation();

    if (isAuthenticated) {
        const fromLocation = location.state?.from;
        const fromPath = fromLocation
            ? `${fromLocation.pathname}${fromLocation.search}`
            : `${baseRoute}/profile`;
        
        const fromState = location.state?.pendingAction || fromLocation?.state || null;

        if (user && !user.emailVerifiedAt) {
            return (
                <Navigate
                    to={`${baseRoute}/verify-email`}
                    state={{ fromPath, fromState }}
                    replace
                />
            );
        }

        return <Navigate to={fromPath} state={fromState} replace />;
    }

    return <Outlet />;
}
